import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { Review } from '../types';
import { StarRating } from './StarRating';
import { Card } from './Card';
interface ReviewCardProps {
  review: Review;
}
export function ReviewCard({
  review
}: ReviewCardProps) {
  return <Card className="p-5" data-id="element-105">
      <div className="flex items-start justify-between mb-3" data-id="element-106">
        <div data-id="element-107">
          <div className="flex items-center gap-2 mb-1" data-id="element-108">
            <span className="font-semibold text-slate-900" data-id="element-109">
              {review.author}
            </span>
            {review.verified && <div className="flex items-center gap-1 text-green-600 text-xs" data-id="element-110">
                <CheckCircleIcon size={14} data-id="element-111" />
                <span data-id="element-112">Verified</span>
              </div>}
          </div>
          <StarRating rating={review.rating} size={14} data-id="element-113" />
        </div>
        <span className="text-sm text-slate-500" data-id="element-114">{review.date}</span>
      </div>
      <p className="text-slate-700 leading-relaxed" data-id="element-115">{review.comment}</p>
    </Card>;
}